export const zeroValidation = (rule, value, callback) => {
    if (Number(value) <= 0) {
        callback("Must be 1 or higher");
    } else {
        callback();
    }
};
